import { Alert, Space } from 'antd';
import { useState } from 'react';

import { NurseProfileDto, ShiftListItemDto } from '@clh/api-client';
import { useApiClient } from '@clh/ui';

import { ActionButton } from '../../../action-button';
import { useSelection } from '../../../hooks/use-selection';
import ProfileAutoComplete from '../../../profiles/profile-autocomplete';

export const AssignNurse = ({ close }: { close: () => void }) => {
    const api = useApiClient();
    const [selectedNurse, setSelectedNurse] = useState<NurseProfileDto>();
    const { selection, setSelection } = useSelection<ShiftListItemDto>();

    return (
        <Space direction="vertical" style={{ width: 320 }}>
            <Space direction="horizontal">
                <ProfileAutoComplete
                    onSelect={(nurse) => {
                        setSelectedNurse(nurse);
                    }}
                />

                <ActionButton
                    disabled={!selectedNurse}
                    successMessage="Nurse assigned"
                    action={async () => {
                        if (!selectedNurse) {
                            throw Error('Must select a nurse to assign');
                        }

                        if (selection.isClaimable) {
                            await api?.shiftControllerClaimShift({
                                shiftId: selection.id,
                                profileId: selectedNurse.id,
                            });
                        } else {
                            await api?.shiftControllerRequestNurse({
                                shiftId: selection.id,
                                profileId: selectedNurse.id,
                            });

                            await api?.shiftControllerAcceptFacilityRequest({
                                shiftId: selection.id,
                                profileId: selectedNurse.id,
                            });
                        }

                        setSelection({
                            ...selection,
                            nurseProfile: selectedNurse,
                        });
                        close();
                    }}
                >
                    Assign Nurse
                </ActionButton>
            </Space>
            {selectedNurse && (
                <Alert
                    message={`This will assign the shift to ${selectedNurse.firstName} ${selectedNurse.lastName}. Email and SMS notifications will be sent to the nurse and facility.`}
                    type="warning"
                />
            )}
        </Space>
    );
};
